/* eslint-disable default-case */
import {
  DaskInsuranceType,
  HealthInsuranceType,
  KaskoInsuranceType,
  TrafficInsuranceType,
  TravelInsuranceType,
} from "./InsuranceTypes";
import {
  PermissionInsuranceRequestsApprove,
  PermissionInsuranceRequestsDecline,
  PSectionInsuranceRequests,
  PermissionInsuranceRequestsToggleLock,
  PermissionInsuranceRequestsChangeToWaitingPrice,
  PermissionInsuranceRequestsRequestSecondYear,
  PermissionInsuranceRequestsModifyDate,
  PermissionInsuranceRequestsHide,
  PermissionInsuranceRequestsMove,
  PermissionInsuranceRequestsReplaceFiles,
  PermissionInsuranceRequestsResendFile,
  PermissionInsuranceRequestsTryFetchFile,
  PermissionInsuranceRequestsChangeCountry,
  PermissionInsuranceRequestsChangeDaskInfo,
  PermissionInsuranceRequestsMovePriceSet,
  PermissionInsuranceRequestsChangeSponsorInfo,
} from "./Permissions";
import {
  RequestStatusApproved,
  RequestStatusPriceSet,
  RequestStatusPriceApproved,
  RequestStatusProcessing,
  RequestStatusWaitingForApproval,
  RequestStatusPriceDeclined,
  RequestStatusDeclined,
  RequestStatusWaitingForPrice,
  RequestStatusWaitingForEditing,
  RequestStatusWaitingForCancellation,
} from "./RequestStatuses";

class InsurancesPagesHelper {
  static showColumn(column, insuranceRequest, permissions = null) {
    switch (column) {
      case "file":
        switch (insuranceRequest.statusValue) {
          case RequestStatusPriceSet:
          case RequestStatusPriceApproved:
            return false;
          case RequestStatusApproved:
            return true;
        }
        break;
      case "enfile":
      case "trfile":
      case "trcertificatefile":
      case "encertificatefile":
        switch (insuranceRequest.typeValue) {
          case TravelInsuranceType:
            if (insuranceRequest.statusValue !== RequestStatusProcessing) {
              return true;
            }
            return false;
          default:
            return false;
        }
      case "accept":
        if (insuranceRequest.statusValue === RequestStatusPriceSet) {
          return true;
        }
        return false;
      case "decline":
        if (insuranceRequest.statusValue === RequestStatusPriceSet) {
          return true;
        }
        return false;
      case "agency-request-buttons":
        switch (insuranceRequest.typeValue) {
          case DaskInsuranceType:
            return false;
          case TravelInsuranceType:
          case HealthInsuranceType:
          case TrafficInsuranceType:
          case KaskoInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusApproved:
                return true;
            }
            return false;
        }
        return false;
      case "system-agency-request-accept":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsApprove
          ]
        ) {
          return false;
        }
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
          case RequestStatusDeclined:
          case RequestStatusPriceApproved:
          case RequestStatusPriceDeclined:
            return true;
        }
        switch (insuranceRequest.statusValue2) {
          case RequestStatusWaitingForApproval:
          case RequestStatusWaitingForEditing:
          case RequestStatusWaitingForCancellation:
            return true;
        }
        return false;
      case "system-agency-request-decline":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsDecline
          ]
        ) {
          return false;
        }
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
          case RequestStatusPriceSet:
          case RequestStatusWaitingForPrice:
          case RequestStatusPriceApproved:
          case RequestStatusPriceDeclined:
            return true;
          case RequestStatusApproved:
            // if (insuranceRequest.typeValue === DaskInsuranceType) {
            //   return false;
            // }
            return true;
        }
        switch (insuranceRequest.status2) {
          case RequestStatusWaitingForApproval:
          case RequestStatusWaitingForEditing:
          case RequestStatusWaitingForCancellation:
            return true;
        }
        return false;
      case "system-agency-exchange":
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
            switch (insuranceRequest.typeValue) {
              case HealthInsuranceType:
                return true;
            }
            return false;
        }
        return false;
      case "agency-no-action-exists":
        switch (insuranceRequest.statusValue) {
          case RequestStatusPriceApproved:
          case RequestStatusWaitingForPrice:
          case RequestStatusDeclined:
          case RequestStatusProcessing:
          case RequestStatusPriceDeclined:
            return true;
        }
        return false;
      case "set-price":
        switch (insuranceRequest.statusValue) {
          case RequestStatusWaitingForPrice:
            return true;
        }
        return false;
      case "change-price":
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
          case RequestStatusDeclined:
          case RequestStatusPriceApproved:
          case RequestStatusApproved:
            return true;
        }
        return false;
      case "retry-travel-insurance":
        switch (insuranceRequest.typeValue) {
          case TravelInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusProcessing:
                return true;
            }
            return false;
        }
        return false;
      case "reset-insurance-request-processing":
        switch (insuranceRequest.typeValue) {
          case TravelInsuranceType:
          case HealthInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusProcessing:
                return true;
            }
            return false;
          case DaskInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusPriceApproved:
              case RequestStatusPriceSet:
              case RequestStatusWaitingForPrice:
                return true;
            }
            return false;
        }
        return false;
      case "retry-insurance-request-pricing":
        switch (insuranceRequest.typeValue) {
          case TrafficInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusWaitingForPrice:
                return true;
            }
            return false;
        }
        return false;
      case "set-note":
        return true;
      case "system-agency-set-insurance-policy-id":
        if (insuranceRequest.statusValue === RequestStatusApproved) {
          return true;
        }
        return false;
      case "system-agency-change-identity-no":
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
          case RequestStatusDeclined:
          case RequestStatusPriceApproved:
            return true;
        }
        return false;
      case "toggle-insurance-request-lock":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsToggleLock
          ]
        ) {
          return false;
        }
        return true;
      case "allow-adding-insurance-request-price":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsChangeToWaitingPrice
          ]
        ) {
          return false;
        }
        if (insuranceRequest.statusValue === RequestStatusPriceSet) {
          return true;
        }
        return false;
      case "request-second-year-insurance-request":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsRequestSecondYear
          ]
        ) {
          return false;
        }
        if (insuranceRequest.statusValue === RequestStatusApproved) {
          return true;
        }
        return false;
      case "move-insurance-request":
        return permissions[PSectionInsuranceRequests][
          PermissionInsuranceRequestsMove
        ];
      case "modify-insurance-request-date":
        return permissions[PSectionInsuranceRequests][
          PermissionInsuranceRequestsModifyDate
        ];
      case "hide-insurance-request":
        return permissions[PSectionInsuranceRequests][
          PermissionInsuranceRequestsHide
        ];
      case "replace-insurance-request-files":
      case "replace-insurance-request-files":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsReplaceFiles
          ]
        ) {
          return false;
        }
        if (insuranceRequest.statusValue === RequestStatusApproved) {
          return true;
        }
        return false;
      case "insurance-request-change-country":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsChangeCountry
          ]
        ) {
          return false;
        }
        if (insuranceRequest.typeValue !== HealthInsuranceType) {
          return false;
        }
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
            return true;
        }
        return false;
      case "insurance-request-change-dask-info":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsChangeDaskInfo
          ]
        ) {
          return false;
        }
        if (insuranceRequest.typeValue !== DaskInsuranceType) {
          return false;
        }
        switch (insuranceRequest.statusValue) {
          case RequestStatusWaitingForPrice:
            return true;
        }
        return false;
      case "try-to-fetch-insurance-request-file":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsTryFetchFile
          ]
        ) {
          return false;
        }
        switch (insuranceRequest.statusValue) {
          case RequestStatusProcessing:
            return true;
        }
        return false;
      case "move-price-set":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsMovePriceSet
          ]
        ) {
          return false;
        }
        switch (insuranceRequest.typeValue) {
          case DaskInsuranceType:
          case TrafficInsuranceType:
          case KaskoInsuranceType:
            switch (insuranceRequest.statusValue) {
              case RequestStatusPriceSet:
                return true;
            }
            return false;
        }
        return false;
      case "update-insurance-request-sponsor-info":
        if (
          !permissions[PSectionInsuranceRequests][
            PermissionInsuranceRequestsChangeSponsorInfo
          ]
        ) {
          return false;
        }
        switch (insuranceRequest.typeValue) {
          case HealthInsuranceType:
            if (insuranceRequest.statusValue === RequestStatusProcessing) {
              return true;
            }
            return false;
          default:
            return false;
        }
    }
  }
}

export default InsurancesPagesHelper;
